<script lang="ts" setup>
  import { Toaster as Sonner, type ToasterProps } from 'vue-sonner'

  const props = defineProps<ToasterProps>()
</script>

<template>
  <sonner
    class="toaster group"
    v-bind="props"
    :style="{
      '--normal-bg': 'var(--popover)',
      '--normal-text': 'var(--popover-foreground)',
      '--normal-border': 'var(--border)',

    }" />
</template>
